import { render, staticRenderFns } from "./ShortTermDiscontinueIntervention.vue?vue&type=template&id=2957c01a&"
import script from "./ShortTermDiscontinueIntervention.vue?vue&type=script&lang=js&"
export * from "./ShortTermDiscontinueIntervention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports